export default {
  en: {
    title: 'Zehitomo | Connect with the best Local Service Professionals',
    seo: {
      description:
        'Spend time on what matters most. No more pointless searching. Negotiate until you are satisfied. No sales phone calls. Pick and choose at zero cost.',
      keywords: 'Zehitomo',
      ogTitle: 'Zehitomo | Connect with the best Local Service Professionals',
      ogDescription:
        'Spend time on what matters most. No more pointless searching. Negotiate until you are satisfied. No sales phone calls. Pick and choose at zero cost.',
      ogImage:
        'https://res.cloudinary.com/zehitomo/image/upload/v1652747398/assets/openGraphLogo.png',
    },
  },
  ja: {
    title: 'ゼヒトモ | あなたの毎日に、プロからのアイディアを。',
    seo: {
      description:
        'ゼヒトモはカメラマンやパーソナルトレーナーなどの、その道のプロに仕事を依頼できるマッチングサービスです。',
      keywords: 'ゼヒトモ, プロ, 近所, 依頼, 見積もり',
      ogTitle: 'ゼヒトモ | あなたの毎日に、プロからのアイディアを。',
      ogDescription:
        'ゼヒトモはカメラマンやパーソナルトレーナーなどの、その道のプロに仕事を依頼できるマッチングサービスです。',
      ogImage:
        'https://res.cloudinary.com/zehitomo/image/upload/v1652747398/assets/openGraphLogo.png',
    },
  },
};
